var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownBronze(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_420_3283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5671 11.6215C24.3279 11.2073 23.73 11.2073 23.4908 11.6215L7.68378 39.0001C7.44462 39.4144 7.74357 39.9322 8.22189 39.9322H19.3226L8.68336 50.4812C8.28936 50.8719 8.56601 51.5438 9.12086 51.5438H40.2123C40.5324 51.5438 40.8001 51.3006 40.8308 50.9819L44.1074 16.9052C44.163 16.3264 43.4643 15.9951 43.0514 16.4045L33.0525 26.3186L24.5671 11.6215Z",
    fill: "#C3724A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20332 16.9052C4.14767 16.3264 4.84643 15.9951 5.25933 16.4045L39.6273 50.4812C40.0213 50.8719 39.7447 51.5438 39.1898 51.5438H8.09844C7.77831 51.5438 7.51058 51.3006 7.47994 50.9819L4.20332 16.9052Z",
    fill: "#F19063"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9999,
    cy: 5.64092,
    rx: 3.18447,
    ry: 3.18447,
    fill: "#C3724A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.18447,
    cy: 10.3011,
    rx: 3.18447,
    ry: 3.18447,
    fill: "#F19063"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.8156,
    cy: 10.3011,
    rx: 3.18447,
    ry: 3.18447,
    fill: "#C3724A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_420_3283",
    x: 0,
    y: 0.456436,
    width: 48,
    height: 51.0874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.231373 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_3283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_420_3283",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownBronze);
export default __webpack_public_path__ + "static/media/crown_bronze.5660c586c4d846a0db24856743c4f6a9.svg";
export { ForwardRef as ReactComponent };